/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    young<yangyang@frippler.com>
  | @Title:     模型管理-图标 API
  | @Version:   2019-03-08  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getAllIconApi(params) {
  return request({
    url: '?c=dev&a=private-icon&do=getall',
    method: 'get',
    params
  })
}

export function listIconApi(params) {
  return request({
    url: '?c=dev&a=private-icon&do=list',
    method: 'get',
    params
  })
}

export function postIconApi(data) {
  return request({
    url: '?c=dev&a=private-icon&do=post',
    method: 'post',
    data
  })
}

export function deleteIconApi(iconids) {
  return request({
    url: '?c=dev&a=private-icon&do=delete',
    method: 'post',
    data: {
      iconids
    }
  })
}

export function rankIconApi(data) {
  return request({
    url: '?c=dev&a=private-icon&do=displayorder',
    method: 'post',
    data
  })
}

export function getAllPublicIconApi(params) {
  return request({
    url: '?c=dev&a=public-icon&do=getall',
    method: 'get',
    params
  })
}

export function listPublicIconApi(params) {
  return request({
    url: '?c=dev&a=public-icon&do=list',
    method: 'get',
    params
  })
}

export function appendPublicIconApi(data) {
  return request({
    url: '?c=dev&a=public-icon&do=append',
    method: 'post',
    data
  })
}
